import classes from "./css/banner.module.css";
import ME from "../../assets/images/Hero/vs.jpeg";
import CircularText from "./helpershero/circularText";
import { Link } from "react-router-dom";
const Banner = () => {
  const HeroText = "vivek sharma";

  return (
    <>
      <div className={classes.bannerComponent}>
        <div className={classes.heroText}>{HeroText}</div>
        <div className={classes.heroItems}>
          <div className={classes.something}>
            <CircularText
              text="THINK*BUILD*DEBUG*DOMINATE*"
              onHover="speedUp"
              spinDuration={20}
              className="custom-class"
            />
          </div>
          <div className={classes.heroImage}>
            <img src={ME} alt="Vivek Sharma" />
          </div>
          <div className={classes.heroAbout}>
            <div className={classes.heroAboutText}>
              Hi, I’m Vivek, a developer who loves building robust systems and
              writing clean, efficient code. I turn ideas into smooth, scalable
              solutions through logic and precision.
            </div>
            <Link
              to="/VivekSharma/lets-connect"
              className={classes.heroAboutButton}
            >
              <span>Get in touch</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Banner;
